// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_d58","cls2":"ReferenceReportPage-cls2_2N9 ReferenceReportPage-cls1_d58"};